import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { DeliveryScheduleCollectiveEditConfirmTemplate } from 'components/Templates'

const DeliveryScheduleCollectiveEditConfirm: FC = () => {
  return (
    <Layout title={`確認 | お届け可能日を一括設定`}>
      <DeliveryScheduleCollectiveEditConfirmTemplate />
    </Layout>
  )
}

export default DeliveryScheduleCollectiveEditConfirm
